import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';

import { RestService } from './rest.service';

@Injectable()
export class BallotMatrixService {
  constructor(private readonly rest: RestService) {}

  getBallotMatrix(): Promise<any> {
    return this.rest.get(`${environment.apiUrl}/api/core/ballot-matrix`);
  }

  createBallotType(payload: any): Promise<any> {
    return this.rest.post(`${environment.apiUrl}/api/core/ballot-matrix/ballot-type`, payload);
  }

  updateBallotType(id: number, payload: any): Promise<any> {
    return this.rest.put(`${environment.apiUrl}/api/core/ballot-matrix/ballot-type/${id}`, payload);
  }

  createAssignment(payload: any): Promise<any> {
    return this.rest.post(`${environment.apiUrl}/api/core/ballot-matrix/assignment`, payload);
  }

  updateAssignment(id: number, payload: any): Promise<any> {
    return this.rest.put(`${environment.apiUrl}/api/core/ballot-matrix/assignment/${id}`, payload);
  }

  deleteAssignment(id: number): Promise<any> {
    return this.rest.delete(`${environment.apiUrl}/api/core/ballot-matrix/assignment/${id}`);
  }
}
